export const generateLocalBusinessSchema = (city?: string) => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Elektra Aanleg",
  image: "https://elektraaanleg.nl/og-image.jpg", // Replace with actual image URL
  description: `Uw lokale elektricien voor Elektricien Arnhem${
    city ? ` in ${city}` : ""
  }. Wij bieden snelle en betrouwbare service voor al uw elektrische werkzaamheden.`,
  address: {
    "@type": "PostalAddress",
    streetAddress: "Laan van Vollenhove 2935",
    addressLocality: "Zeist",
    postalCode: "3706 AK",
    addressCountry: "NL",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 52.0895, // Correct latitude for Zeist
    longitude: 5.2425, // Correct longitude for Zeist
  },
  url: "https://elektraaanleg.nl",
  email: "info@elektraaanleg.nl",
  telephone: "+31852129778",
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "07:00",
      closes: "18:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Saturday"],
      opens: "12:00",
      closes: "17:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Sunday"],
      opens: "Closed",
      closes: "Closed",
    },
  ],
  sameAs: [
    "https://facebook.com/elektraaanleg",
    "https://instagram.com/elektraaanleg",
    "https://linkedin.com/company/elektraaanleg",
  ],
  vatID: "NL866593433B01",
  registrationNumber: "93984707",
});
